export function buildPrompt({
  mode,
  param1,
  param2,
  selectedAction,
  selectedLanguageName,
  wordLimit,
  outputFormat,
  rcaRuleBlock,
  notesType,
  audienceGender,
  audienceAge,
  audienceName
}) {
  const trimmedParam1 = (param1 || "").trim();
  const trimmedParam2 = (param2 || "").trim();

  // const audienceContext = [
  //   audienceGender ? `Audience gender: ${audienceGender}.` : "",
  //   audienceAge ? `Audience age group: ${audienceAge}.` : "",
  // ]
  //   .filter(Boolean)
  //   .join(" ");

  // return audienceContext
  //   ? `${audienceContext} ...\n\n${basePrompt}`
  //   : basePrompt;

// console.log("Here in buildPrompt");
  // ==============================
  // MSME TASK ASSISTANCE
  // ==============================
  if (mode === "msme_owner_task_assistance") {
    return `You are an expert MSME Business Operations Assistant and Task Refinement Specialist.

Help me for ${param1}

Here is the task information:
${trimmedParam2}

Please ${selectedAction ? selectedAction.toLowerCase() : "refine and improve"} this To-Do task.

Requirements:
- Make title short, clear, and action-oriented
- Make description specific, measurable, and practical for MSME owner
- Suggest realistic next steps or deadlines if possible
- Maintain professional but simple language
- Respond in ${selectedLanguageName || "English"}
- Maximum ${wordLimit} characters / tokens
- Output format: ${outputFormat}
Only return the improved version of the task.`;
  }

  // ==============================
  // LIFE MOOD DASHBOARD
  // ==============================
  
  else if (mode === "daily_life_mood_dashboard") {
    return `You are a Life Behavior Intelligence AI.

Context:
${trimmedParam2}

Task:
Analyze emotional and behavioral patterns from LifeReplay mood data.

Focus:
- Emotional stability trends
- Motivation cycles
- Productivity vs burnout signals
- High vs low energy phases
- Long-term behavioral trajectory

Rules:
- Do NOT describe JSON
- Do NOT repeat raw data
- Focus only on behavioral insights

Output:
1. Emotional Profile Summary
2. Core Behavioral Pattern
3. Key Insights
4. Risk / Positive Signals
5. Recommendations

Language: ${selectedLanguageName || "English"}
Limit: ${wordLimit}
Format: ${outputFormat}`;
  }

// ==============================
// Purple DASHBOARD
// ==============================
else if (mode === "daily_smart_to_do") {
    return `Help me for ${trimmedParam1} as per following details:
    ${trimmedParam2}
Language: ${selectedLanguageName || "English"}
Limit: ${wordLimit}
Format: ${outputFormat}`;
  }
else if (mode === "daily_life_mood") {
    return `Help me for ${trimmedParam1} as per following details:
    ${trimmedParam2}
Language: ${selectedLanguageName || "English"}
Limit: ${wordLimit}
Format: ${outputFormat}`;
  }
  else if (mode === "post_a_hustles") {
    return `Help me as ${trimmedParam1} as per following details:
    ${trimmedParam2}
Language: ${selectedLanguageName || "English"}
Limit: ${wordLimit}
Format: ${outputFormat}`;
  }
 else if (mode === "post_for_local_classified") {
    return `Help me as ${trimmedParam1} as per following details:
    ${trimmedParam2}
Language: ${selectedLanguageName || "English"}
Limit: ${wordLimit}
Format: ${outputFormat}`;
  }
else if (mode === "purpledoor_90d_task_dashboard") {
  return `You are a Daily Activity Intelligence AI.

Context:
${trimmedParam2}

Task:
Analyze daily activity patterns from PurpleDoor daily data.

Focus:
- Activity consistency and participation trends
- Progress trajectory across the last 90 days
- Learning, challenge, certification, and execution patterns
- Engagement signals (active, improving, declining, inactive)
- Achievement and milestone indicators
- Productivity, discipline, and habit-building signals
- Growth opportunities and improvement areas
- Positive and risk signals affecting long-term development

Rules:
- Do NOT describe JSON
- Do NOT repeat raw data
- Focus only on behavioral insights

Output:
1. 90-Day Progress Summary
2. Activity & Engagement Analysis
3. Consistency & Discipline Signals
4. Achievement & Growth Indicators
5. Strength Areas
6. Improvement Opportunities
7. Risk & Positive Signals
8. Actionable Recommendations
9. Overall Growth Outlook

Language: ${selectedLanguageName || "English"}
Limit: ${wordLimit}
Format: ${outputFormat}`;
  }

else if (mode === "scoreplus_list") {
    return `Help me for ${trimmedParam1} as per following details:
    ${trimmedParam2}
Language: ${selectedLanguageName || "English"}
Limit: ${wordLimit}
Format: ${outputFormat}`;
  }
  // ==============================
  // DOCUMENT CONSENT
  // ==============================
  else if (mode === "document_consent") {
    return `You are a Document Consent Intelligence AI inside a Consent Governance System.

${param1}
${selectedAction ? selectedAction.toLowerCase() : "the following consent-related signals or document metadata:"}

${trimmedParam2}

Perform:
- Consent validity check
- Risk identification
- Missing consent detection
- Audit readiness assessment
- Suggest corrective actions

Return structured output:
1. Consent Status
2. Risk Level
3. Compliance Issues
4. Recommendations
5. Next steps

Respond in ${selectedLanguageName || "English"}.
Maximum ${wordLimit} tokens.
Format: ${outputFormat}`;
  }

  // ==============================
  // HOSTEL RCA
  // ==============================
  else if (
    mode === "hostel_rca_improvement_assistant" ||
    mode === "hostel_rca_input_assistant"
  ) {
    return `You are a Hostel Ecosystem Expert.

Context: Hostel RCA Assistance
RCA Input:
${trimmedParam2}

Task:
- Analyze root issues
- Identify risks
- Provide actionable recommendations

${rcaRuleBlock}`;
  }

  // ==============================
  // HAFH MODE
  // ==============================
  else if (mode === "hafa_home_away_from_home") {
    return `You are a Hostel / PG Ecosystem Expert.

Context: ${param1}
${selectedAction ? selectedAction.toLowerCase() : ""}

${trimmedParam2}

Return:
1. Summary
2. Key Issues
3. Insights
4. Recommendations
5. Next Steps

Respond in ${selectedLanguageName || "English"}.
Max ${wordLimit} tokens.
Format: ${outputFormat}`;
  }

  // ==============================
  // APPLAUSE
  // ==============================
  else if (mode === "hostel_applause" || mode === "hostel_applause_creation") {
    return `You are an AI advisor for Hostel Recognition System.

Context:
${trimmedParam2}

Task:
1. Understand contribution
2. Evaluate impact
3. Suggest recognition ideas

Format:
1. Summary
2. Insight
3. Impact
4. Recommendations

Language: ${selectedLanguageName || "English"}
Limit: ${wordLimit}
Format: ${outputFormat}`;
}

else if (mode === "daily_pulse_mood_resilience") {
    return `The user is answering a Daily Pulse assessment.

Context:
${trimmedParam2}

Task:
Your goal is NOT to answer the question.
Your goal is to help the user understand what this question is really asking so they can answer honestly.

Please provide your response in exactly these sections:
                                                        
🧠 What does this question mean?
Explain in very simple everyday language (2-3 sentences).

💡 Why does this matter?
Explain how this affects emotional wellbeing, productivity, relationships, or daily life.

🔍 Think before you answer
Give 2-3 reflection prompts that help the user decide which option best describes today.

⚡ Small Action
Suggest one simple action the user can do today if they realize this is becoming a problem.

✨ Friendly Reminder
End with one short, encouraging sentence that reminds the user there are no right or wrong answers—only honest ones.


Format:
Use a warm, supportive, Gen-Z friendly tone without being overly casual.

Language: ${selectedLanguageName || "English"}
Limit: 40 tokens
Format: ${outputFormat}`;
}

  // ==============================
  // HerKart
  // ==============================
  else if (mode === "herkart_product_tts_script") {
    return `${trimmedParam2}

    Format:
Use a warm, supportive, Gen-Z friendly tone without being overly casual.
Output only the raw spoken script text — nothing else. No headings, no numbered sections, 
no "Summary" or "Recommendations" labels, no markdown, no preamble, no closing remarks. 
Just the script, ready to paste directly into a form field.
Language: ${selectedLanguageName || "English"}`;
  }

  else if (mode === "herkart_product_customer_qna") {
  return `${trimmedParam2}
Language: ${selectedLanguageName || "English"}
Output only the natural spoken/written answer — no headings, no numbered sections, no markdown, no preamble.`;
}

else if (mode === "herkart_service_tts_script") {
  return `${trimmedParam2}
Language: ${selectedLanguageName || "English"}
Output only the raw spoken script text — nothing else. No headings, no numbered sections, no markdown, no preamble.`;
}

else if (mode === "herkart_service_customer_qna") {
  return `${trimmedParam2}
Language: ${selectedLanguageName || "English"}
Output only the natural spoken answer — no headings, no numbered sections, no markdown, no preamble.`;
}

else if (mode === "herkart_store_tts_script") {
     return `${trimmedParam2}
Language: ${selectedLanguageName || "English"}
   Output only the raw spoken script text — nothing else. No headings, no numbered sections, no markdown, no preamble.`;
   }

else if (mode === "herkart_translate_tts") {
  return `Translate and naturally adapt the following spoken script into ${selectedLanguageName || "the selected language"}, so it sounds like it was originally written in that language for a Text-to-Speech voice assistant — not a literal word-for-word translation.

Original script:
${trimmedParam2}

Output ONLY the translated spoken text — nothing else. No headings, labels, meta-commentary, markdown, quotation marks, or explanations. Just the translated script, ready to be read aloud or pasted directly.`;
}

else if (mode === "herkart_store_translate_story") {
  const nameLine = audienceName
    ? `The customer listening is named ${audienceName}. Address them warmly by name once near the beginning, the way a shopkeeper would greet a guest by name — naturally, not forced or repeated.`
    : "";
  const genderLine = audienceGender
    ? `The customer is ${audienceGender}. If the target language naturally uses gendered grammar or pronouns for the speaker or listener, use forms appropriate for a ${audienceGender} listener.`
    : "";

  return `${trimmedParam2}

${nameLine}
${genderLine}

Language: ${selectedLanguageName || "English"}
Output only the translated spoken text — nothing else. No headings, no numbered sections, no markdown, no preamble.`;
}
  // ==============================
  // CLEAN FALLBACK (FIXED)
  // ==============================
else {
  return `⚠️ Unsupported AI Prompt Mode: "${mode}"

Context:
- param1: ${trimmedParam1 || "(empty)"}
- Language: ${selectedLanguageName || "English"}

Please contact the Development Team.
`;
}
}